import { useEffect } from "react";
import PasadenaHeroSection from "./components/HeroSection";
import PasadenaStickyNav from "./components/StickyNav";
import PasadenaProcessingTimeSection from "./components/ProcessingTimeSection";
import PasadenaServicesSection from "./components/ServicesSection";
import PasadenaLocalAreaSection from "./components/LocalAreaSection";
import PasadenaTravelTimingSection from "./components/TravelTimingSection";
import PasadenaDestinationsSection from "./components/DestinationsSection";
import PasadenaTestimonialsSection from "./components/TestimonialsSection";
import PasadenaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PasadenaComparisonSection from "./components/ComparisonSection";
import PasadenaMistakesSection from "./components/MistakesSection";
import PasadenaHowItWorksSection from "./components/HowItWorksSection";
import PasadenaFAQSection, { faqs } from "./components/FAQSection";
import PasadenaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PasadenaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function PasadenaPage() {
  useEffect(() => {
    document.title = "Emergency Passport Pasadena, CA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/pasadena/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Pasadena, CA — as fast as 24 hours. Serving Caltech, JPL, Arcadia, and all of the San Gabriel Valley. A+ BBB rated, registered State Dept. courier. Best price guarantee.");
    setMeta("geo.placename", "Pasadena, California");
    setMeta("geo.region", "US-CA");
    setMeta("geo.position", "34.1478;-118.1445");
    setMeta("ICBM", "34.1478, -118.1445");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "California", item: "https://fastpassportcenter.com/california/" },
          { "@type": "ListItem", position: 3, name: "Pasadena Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Pasadena and the San Gabriel Valley — as fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Pasadena", containedInPlace: { "@type": "State", name: "California" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <PasadenaHeroSection />
      <PasadenaStickyNav />
      <PasadenaProcessingTimeSection />
      <PasadenaServicesSection />
      <PasadenaLocalAreaSection />
      <PasadenaTravelTimingSection />
      <PasadenaDestinationsSection />
      <PasadenaTestimonialsSection />
      <PasadenaAcceptanceFacilitiesSection />
      <PasadenaComparisonSection />
      <PasadenaMistakesSection />
      <PasadenaHowItWorksSection />
      <PasadenaFAQSection />
      <PasadenaHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/pasadena" state="CA" />
      <PasadenaFinalCTA />
    </div>
  );
}